import axios from 'axios';
import { useState, useEffect } from 'react';
import { FeedbackTopic } from '../models/FeedbackInterfaces';

export const useGetFeedbackTopics = () => {
  const [feedbackTopics, setfeedbackTopics] = useState<FeedbackTopic[]>();
  const [loadingFeedbackTopics, setLoadingFeedbacksTopics] = useState(false);

  const getFeedbackTopics = async () => {
    setLoadingFeedbacksTopics(true);
    try {
      const response = await axios.get('api/feedback-topic');
      setfeedbackTopics(response.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingFeedbacksTopics(false);
    }
  };

  useEffect(() => {
    getFeedbackTopics();
  }, []);

  return { feedbackTopics, loadingFeedbackTopics };
};
